import { useEffect, useState } from "react";
import { clearStorage, getIsUserLinked } from "@utils/storage";
import { useLinkProspect } from "./useLinkProspect";
import { useHistory } from "react-router-dom";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";
import { useTwoWayAuth } from "@features/TwoWayAuth/hook/useTwoWayAuth";

export const useKeycloak = () => {
    const [isKeycloakLoading, setIsKeycloakLoading] = useState(true);
    const {
        linkProspectUserState,
        createProspectState,
        displayChangedInfoModal,
        setDisplayChangedInfoModal,
    } = useLinkProspect();

    const { push } = useHistory();
    const { handleCheckIfValidated } = useTwoWayAuth();

    useEffect(() => {
        const isLinked = getIsUserLinked();

        if (global.Keycloak) {
            keycloakUtils.init("check-sso", {
                checkLoginIframe: process.env.NODE_ENV !== "development",
            });

            keycloakUtils.setOnAuthSuccess(async () => {
                setIsKeycloakLoading(false);
                /*linkProspect()
                    .then(() => setIsKeycloakLoading(false))
                    .catch(() => setIsKeycloakLoading(false));
                await addUserEmailHashToGTM();*/
            });

            keycloakUtils.setOnAuthLogout(() => {
                clearStorage();
                push("/");
            });

            keycloakUtils.setOnReady(async () => {
                if (!keycloakUtils.isAuthenticated() && isLinked) {
                    clearStorage();
                }
                if (!keycloakUtils.isAuthenticated()) {
                    setIsKeycloakLoading(false);
                }
                if (keycloakUtils.isAuthenticated()) {
                    await handleCheckIfValidated();
                    setIsKeycloakLoading(false);
                }
            });

            keycloakUtils.setOnAuthError(() => {
                setIsKeycloakLoading(false);
            });
        } else {
            setIsKeycloakLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const globalLoading = linkProspectUserState.isLoading || createProspectState.isLoading || isKeycloakLoading;
    const globalError = linkProspectUserState.error ?? createProspectState.error;

    return {
        displayChangedInfoModal,
        globalError,
        globalLoading,
        setDisplayChangedInfoModal,
    };
};
